import { render, staticRenderFns } from "./SpacePrices.vue?vue&type=template&id=30339062"
import script from "./SpacePrices.vue?vue&type=script&lang=js"
export * from "./SpacePrices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports